import moment from 'moment';

export default {
  SET_NOTES: (state, notes) => {
    state.notes = notes;
  },
  ADD_NOTES: (state, note) => {
    state.notes.unshift(note);
  },
  EDIT_NOTE: (state, note) => {
    state.notes = state.notes.map(n => {
      if (n.memoId !== note.memoId) return n;
      n = note;
      return n;
    });
    
    state.notes.sort((n1, n2) => {
      const n1_date = moment(n1.uptDate).format('yyyyMMDDhhmmss')
      const n2_date = moment(n2.uptDate).format('yyyyMMDDhhmmss')
      return n2_date - n1_date;
    });
  },
  DELETE_NOTES: (state, memoId) => {
    state.notes = state.notes.filter(n => n.memoId !== memoId);
  }
};
